import { featureItems } from '@/mocks/home';

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">平台特色</h2>
          <p className="text-sm md:text-base text-foreground-500">为什么800万漫画爱好者选择51漫画</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {featureItems.map((item, idx) => (
            <div key={idx} className="bg-background-50 rounded-xl p-6 group hover:bg-accent-50/30 transition-colors">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="font-semibold text-foreground-950 text-base md:text-lg mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}